import React, { Component } from "react";
import "./CarViewDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { isMobile } from "react-device-detect";
import ExpandCarDetail from "../ExpandCarDetail/ExpandCarDetail";
import { isTSTypeParameterInstantiation } from "@babel/types";

let value = "";
class CarViewDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      open: false,
      patentas: [],
      selectedPrice: 0,
      error: false
    };
    fetch("json/patentas.json")
      .then(r => r.json())
      .then(data => {
        this.setState({
          patentas: data.opciones
        });
      });
  }

  handleChange = event => {
    console.log(event.target.value);
    this.setState({ selectedPrice: event.target.value });
  };

  handleReservar = precio => {
    console.log(precio);
    if (precio === 0) this.setState({ error: true });
    this.props.handleReservar(precio);
  };

  render() {
    return (
      <div>
        <Grid container style={{ textAlign: "center", marginTop: "80px" }}>
          <Grid item xs={12} sm={6}>
            <img src={this.props.image} className="CarImage" />
            <div className="CarChasisDetail">CHASIS Nº {this.props.chasis}</div>
          </Grid>
          {isMobile ? (
            <ExpandCarDetail
              version={this.props.version}
              motor={this.props.motor}
              tipo={this.props.tipo}
              color={this.props.color}
              year={this.props.year}
              gear={this.props.gear}
              titulo1={this.props.titulo1}
              texto1={this.props.texto1}
              titulo2={this.props.titulo2}
              texto2={this.props.texto2}
              titulo3={this.props.titulo3}
              texto3={this.props.texto3}
            />
          ) : null}
          <Grid item xs={12} sm={6} style={{ padding: "0px" }}>
            <Grid
              item
              xs={12}
              sm={12}
              className={isMobile ? "CarGridMobile" : "CarGrid"}
            >
              <div className={isMobile ? "CarModelNameMobile" : "CarModelName"}>
                ¡Muy bien! {isMobile ? <br /> : null}Elegiste el{" "}
                {this.props.nombre} {this.props.version}
              </div>
              <div className={isMobile ? "CarVersionMobile" : "CarVersion"}>
                Armá tu paquete y reservalo al mejor precio del mercado.
              </div>
            </Grid>

            <Grid
              container
              xs={12}
              sm={12}
              offset={1}
              className={isMobile ? "CarDetailGridMobile" : "CarDetailGrid"}
            >
              <Grid
                container
                spacing={0}
                xs={12}
                sm={8}
                offset={1}
                className="CarDetailGridIn"
              >
                <Grid item xs={12} sm={12}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="patenta"
                      name="patenta1"
                      onChange={this.handleChange}
                      className={"RadioGroup"}
                    >
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        className={
                          this.state.patentas.length > 0 &&
                          this.state.selectedPrice ==
                            this.state.patentas[0].precio
                            ? "CarDetailGridCellSelected"
                            : "CarDetailGridCell"
                        }
                      >
                        <Grid item spacing={0} xs={8} sm={8} className="Radio">
                          <FormControlLabel
                            value={
                              this.state.patentas.length > 0
                                ? this.state.patentas[0].precio
                                : null
                            }
                            control={<Radio />}
                            label={
                              this.state.patentas.length > 0
                                ? this.state.patentas[0].titulo
                                : null
                            }
                            className="RadioLabel"
                          />
                          <div className="RadioDetailValido">
                            {this.state.patentas.length > 0
                              ? this.state.patentas[0].subtitulo
                              : null}
                          </div>
                          <div className="RadioDetail">
                            {this.state.patentas.length > 0
                              ? this.state.patentas[0].descripcion
                              : null}
                          </div>
                        </Grid>
                        <Grid
                          item
                          spacing={0}
                          xs={4}
                          sm={4}
                          offset={1}
                          className="RadioPrecio"
                        >
                          $
                          {this.state.patentas.length > 0
                            ? this.state.patentas[0].precio
                            : null}
                          <div className="PriceDetail">
                            {this.state.patentas.length > 0
                              ? this.state.patentas[0].descripcionprecio
                              : null}
                          </div>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        className={
                          this.state.patentas.length > 0 &&
                          this.state.selectedPrice ==
                            this.state.patentas[1].precio
                            ? "CarDetailGridCellSelected"
                            : "CarDetailGridCell"
                        }
                      >
                        <Grid item spacing={0} xs={8} sm={8} className="Radio">
                          <FormControlLabel
                            value={
                              this.state.patentas.length > 0
                                ? this.state.patentas[1].precio
                                : null
                            }
                            control={<Radio />}
                            label={
                              this.state.patentas.length > 0
                                ? this.state.patentas[1].titulo
                                : null
                            }
                            className="RadioLabel"
                          />
                          <div className="RadioDetail">
                            {this.state.patentas.length > 0
                              ? this.state.patentas[1].descripcion
                              : null}
                          </div>
                        </Grid>
                        <Grid
                          item
                          spacing={0}
                          xs={4}
                          sm={4}
                          offset={1}
                          className="RadioPrecio"
                        >
                          $
                          {this.state.patentas.length > 0
                            ? this.state.patentas[1].precio
                            : null}
                          <div className="PriceDetail">
                            {this.state.patentas.length > 0
                              ? this.state.patentas[1].descripcionprecio
                              : null}
                          </div>
                        </Grid>
                      </Grid>
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                className={
                  isMobile
                    ? "CarDetailGridCellPriceMobile"
                    : "CarDetailGridCellPrice"
                }
              >
                <div className={isMobile ? "PrecioMobile" : "Precio"}>
                  Precio Final <br />
                  <div style={{ fontSize: "0.8rem", color: "#EC1C24" }}>
                    Con Patentamiento
                  </div>{" "}
                  <div className={isMobile ? "PrecioNumMobile" : "PrecioNum"}>
                    <b>
                      $
                      {parseInt(this.props.price) +
                        parseInt(this.state.selectedPrice)}
                    </b>
                  </div>{" "}
                  <br />
                  <div
                    onClick={() =>
                      this.handleReservar(this.state.selectedPrice)
                    }
                  >
                    <img
                      src="./img/reservar.png"
                      className={
                        isMobile
                          ? "ReservarImgDetailMobile"
                          : "ReservarImgDetail"
                      }
                    ></img>
                  </div>
                  <div style={{ fontSize: "0.8rem", color: "#EC1C24" }}>
                    {this.state.error
                      ? "Seleccione una opción de patentamiento"
                      : null}
                  </div>{" "}
                  <br />
                  <div className={isMobile ? "MinimoMobile" : "Minimo"}>
                    mínimo de reserva <br />
                    <b>$5.000</b> <br /> <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default CarViewDetail;
